import './commentCard.scss';
import { ReactComponent as accountCircle } from '../../../../../icons/account_circle.svg';
import { ReactComponent as event } from '../../../../../icons/event.svg';
import { CommentCardProps } from "./types/commentCardProps";
import { AdditionalIcon } from "../../../../../components/shared/additionalIcon/additionalIcon";
import { iconStyle, stylizationVerticalAlign } from "../../../../../components/shared/stylization";
import ButtonField from "../../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../../components/buttonField/types/buttonFieldProps";
import { ReactComponent as checkCircle } from '../../../../../icons/check_circle.svg';
import { ReactComponent as edit } from '../../../../../icons/edit.svg';
import { ReactComponent as deleteIcon } from '../../../../../icons/delete.svg';
import { ReactComponent as expandLess } from '../../../../../icons/expand_less.svg';
import { formattedDate } from '../../../../../helpers/dateHelper';
import { useContext, useEffect, useState } from 'react';
import TextAreaField from '../../../../../components/textAreaField/textAreaField';
import { TextAreaFieldProps } from '../../../../../components/textAreaField/types/textAreaFieldProps';
import KrFormContext, { FormComment } from '../../../../../contexts/krFormContext';
import SecondaryCommentCard from './secondaryCommentCard';
import AuthContext from '../../../../../contexts/authContext';
import { getFieldNameByFieldDict } from '../fieldDict';

const CommentCard = (props: CommentCardProps) => {
    const { username } = useContext(AuthContext);
    const { krForm, setkrForm } = useContext(KrFormContext);
    const [showSecondaryComments, setShowSecondaryComments] = useState<boolean>(false);
    const [showEditNewCommentField, setShowEditNewCommentField] = useState<boolean>(false);
    const [highlightComment, setHighlightComment] = useState<boolean>(false);
    const [showFirstReplyField, setShowFirstReplyField] = useState<boolean>(false);
    const [newCommentContent, setNewCommentContent] = useState<string>("");
    const [disableBtn, setDisableBtn] = useState<boolean>(true);
    
    useEffect(() => {
        if (props.primaryComment?.comments && props.primaryComment?.comments.length === 0 && showSecondaryComments) setShowSecondaryComments(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.primaryComment?.comments]);
    
    const getBtnProps = (onClick: any, btnClass: string, placeholder: string, icon: any, disable: boolean): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${btnClass} filterBtn body-txt-medium`,
                style: {
                    height: "40px"
                },
                disabled: disable
            },
            placeHolder: placeholder,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: "auto"
                }
            }
        }
    }

    var textareaProps: TextAreaFieldProps = {
        textAreaPlaceholder: "Wpisz komentarz",
        type: "text",
        keepPristine: true,
        value: newCommentContent,
        setValue: (value: any) => {
            setNewCommentContent(value);
        },
        onFill: (isFill: boolean) => {
            setDisableBtn(!isFill);
        },
        textareaSharedProps: {
            style: {
                height: "200px"
            }
        }
    }

    const handleCommentMarkerClick = () => {
        if (props.primaryComment?.comments && props.primaryComment?.comments!.length > 0) setShowSecondaryComments(!showSecondaryComments)
    }

    const handleHideSecondaryCommentsClick = () => {
        setShowSecondaryComments(false)
    }

    const handleMarkAsCorrectedClick = () => {
        var editedComment: FormComment = {...props.primaryComment};
        editedComment.czY_POPRAWIONE = props.primaryComment?.czY_POPRAWIONE === 1 ? 0 : 1;

        editComment(editedComment);
    }

    const handleConfirmEditCommentClick = () => {
        setShowEditNewCommentField(false);
        var editedComment: FormComment = {...props.primaryComment};
        editedComment.tresc = newCommentContent;
        editComment(editedComment);
    }

    const editComment = (editedComment: FormComment) => {
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = form.formComments.map((item: FormComment) => item.localUUID === editedComment.localUUID ? editedComment : item );
        form.formComments = newComments;
        setkrForm(form);
    }

    const handleFirstReplyClick = () => {
        setNewCommentContent("");
        setShowFirstReplyField(true);
    }

    const handleCancelFirstReplyClick = () => {
        setShowFirstReplyField(false);
    }

    const handleConfirmFirstReplyClick = () => {
        var newComment: FormComment = {
            poczekalniA_ID: krForm.waitingRoomId,
            atrybuT_KOMENTOWANY: props.primaryComment?.atrybuT_KOMENTOWANY,
            datA_KOMENTARZA: new Date().getTime(),
            tresc: newCommentContent,
            autor: username,
            czY_POPRAWIONE: 0,
            komentarZ_GID: props.primaryComment?.globalid,
            localUUID: crypto.randomUUID()
        }
        setShowFirstReplyField(false);
        
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = [...form.formComments, newComment]
        form.formComments = newComments;
        setkrForm(form);
    }

    const handleDeleteCommentClick = () => {
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = form.formComments.filter((item: FormComment) => item.localUUID !== props.primaryComment?.localUUID);
        form.formComments = newComments;
        setkrForm(form);
    }

    const handleEditCommentClick = () => {
        setNewCommentContent(props.primaryComment?.tresc!)
        setShowEditNewCommentField(true);
    }

    const handleCancelEditCommentClick = () => {
        setShowEditNewCommentField(false);
    }

    const handleCommentClickForScroll = () => {
        if (!highlightComment && props.executeScroll) {
            props.executeScroll(props.primaryComment?.atrybuT_KOMENTOWANY);
            setHighlightComment(true);
            setTimeout(() => {
                setHighlightComment(false);
            }, 3000);
        }
    }

    return (
        <>
            {props.isFirstForSection && <h3 className='commentSectionName'>{props.primaryComment?.sectionHeading}</h3>}
            <h4 className='commentFieldName'>{getFieldNameByFieldDict(props.primaryComment?.atrybuT_KOMENTOWANY!, props.isLandslide!, props.is2007!)}</h4>
            <div className="primaryCommentCard">
                <div style={{marginLeft: "10px", marginRight: "10px"}}>
                    <div className="commentInfoPanel boldBtnText">
                        <div className="commentInfoBtns body-txt-medium">{AdditionalIcon(accountCircle, iconStyle)} <span>autor</span> {props.primaryComment?.autor?.replace(".", " ")}</div>
                        <div className="commentInfoBtns body-txt-medium">{AdditionalIcon(event, iconStyle)} <span>data</span> {formattedDate(new Date(new Date(props.primaryComment?.datA_KOMENTARZA)))}</div>
                    </div>
                    <div className={`${highlightComment ? "highlightComment" : ""} commentText body-txt-large`} style={{whiteSpace: "pre-line"}} onClick={handleCommentClickForScroll}>
                        {props.primaryComment?.tresc}
                    </div>
                </div>
                {(showEditNewCommentField || showFirstReplyField) &&
                    <>
                        <div>
                            <TextAreaField {...textareaProps}/>
                        </div>
                        <div className='commentInfoPanel'>
                            <div className="commentActionBtns" style={{paddingBottom: "20px"}}>
                                <ButtonField {...getBtnProps(showEditNewCommentField ? handleCancelEditCommentClick : handleCancelFirstReplyClick, classNameBtn.SmallSecondary, "Anuluj", undefined, false)}></ButtonField>   
                                <ButtonField {...getBtnProps(showEditNewCommentField ? handleConfirmEditCommentClick : handleConfirmFirstReplyClick, classNameBtn.Small, "Dodaj komentarz", undefined, disableBtn)}></ButtonField>                      
                            </div>
                        </div>
                    </>
                }
                <div className="commentInfoPanel">
                    <div className={`commentMarker ${props.primaryComment?.comments && props.primaryComment?.comments.length > 0 ? "" : "noPointer"}`} 
                    onClick={handleCommentMarkerClick}>
                        <p className="bubble body-txt-medium" style={{fontWeight: "600"}}> { props.primaryComment?.comments!.length } </p>
                        <p className={`body-txt-medium-xs ${showSecondaryComments ? "orangeText" : ""}`}>Komentarze</p>
                    </div>
                    <div className="commentActionBtns">
                        {props.editMode && 
                            <ButtonField {...getBtnProps(handleMarkAsCorrectedClick, 
                                `${props.primaryComment?.czY_POPRAWIONE === 1 ? classNameBtn.SmallSuccess : classNameBtn.SmallSecondaryGray} boldBtnText`, 
                                "poprawione", checkCircle, !props.editMode)}></ButtonField>
                        }
                        {props.editMode && props.primaryComment?.comments?.length === 0 && 
                            <ButtonField {...getBtnProps(handleFirstReplyClick, classNameBtn.Small, "Odpowiedz", undefined, showFirstReplyField)}></ButtonField>
                        }
                        {!props.editMode && props.primaryComment?.autor === username && props.primaryComment.czY_POPRAWIONE === 0 &&
                            <>
                                <ButtonField {...getBtnProps(handleEditCommentClick, classNameBtn.SmallPrimaryGray, "", edit, showEditNewCommentField)}></ButtonField>
                                {props.primaryComment.comments?.length === 0 && <ButtonField {...getBtnProps(handleDeleteCommentClick, classNameBtn.SmallPrimaryGray, "", deleteIcon, false)}></ButtonField>}
                            </>
                        }                       
                    </div>
                </div>
            </div>
            {showSecondaryComments && 
                <div className='secondaryComments'>
                    <div className="hideSecondaryComments body-txt-small-orange" onClick={handleHideSecondaryCommentsClick}>
                        <p>Zwiń komentarze</p>
                        {AdditionalIcon(expandLess)}
                    </div>
                    {
                        props.primaryComment?.comments?.map((item, idx) => {
                            return (
                                <SecondaryCommentCard 
                                    key={item.localUUID}
                                    secondaryComment={item}
                                    isLast={idx === (props.primaryComment?.comments?.length! - 1)}
                                    primaryComment={props.primaryComment}
                                />
                            )
                        })
                    }
                </div>
            }
        </>
    );
}

export default CommentCard;